import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import Radios from 'components/shared/FormElements/Radios/Radios';
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
import InsetText from 'components/shared/InsetText/InsetText';
import useFormData from '../../useFormData';

const EnquiryType = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register, handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  const radioButtons = [
    { text: 'Culture and Digital', value: 'Culture and Digital' },
    { text: 'Economy and Innovation', value: 'Economy and Innovation' },
    { text: 'Environment and Energy', value: 'Environment and Energy' },
    { text: 'Housing and Land', value: 'Housing and Land' },
    { text: 'Inclusive Communities', value: 'Inclusive Communities' },
    { text: 'Productivity and Skills', value: 'Productivity and Skills' },
    { text: 'Transport', value: 'Transport' },
    { text: 'Wellbeing', value: 'Wellbeing' },
  ];

  // Add InsetText with extra info when selected option is "no"
  let extraInfo;
  const selectedOption = document.querySelector(
    'input.wmcads-fe-radios__input[name="MayorEnquiry"]:checked'
  );
  if (selectedOption && selectedOption.value === 'no') {
    extraInfo = (
      <InsetText
        classes="wmcads-m-b-lg"
        content="You can always sign up to email alerts later in the disruption alerts dashboard."
      />
    );
  }

  // Check if it is an existing user already
  const { ExistingUser } = useFormData();
  const title = 'What area of WMCA strategy is your enquiry about?';

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      {!ExistingUser && <SectionStepInfo section="Section 1 of 4" description="About you" />}

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <legend className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">{title}</h2>
        </legend>

        <Radios
          name="StrategyEnquiry"
          radios={radioButtons}
          fieldValidation={register({
            required: `Please select one option to proceed`,
          })}
        />

        {extraInfo}
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default EnquiryType;
